/* eslint-disable */
(function($) {
  $(document).on('ready', function() {
    $('[data-show-filter]').on('click', function() {
      $('.news-header').toggleClass('filter-visible');
    });

    $('[data-pixl-load-posts]').click(function() {
      if($(this).hasClass('disabled')) {
        return false;
      }
      var button = $(this),
        data = {
          'action': 'pixl_load_more_posts',
          'query': news_params.posts, // that's how we get params from wp_localize_script() function
          'page': news_params.current_page
        };

      $.post({ // you can also use $.post here
        url: news_params.ajaxurl, // AJAX handler
        data: data,
        type: 'POST',
        beforeSend: function(xhr) {
          button.text('Lädt ...'); // change the button text, you can also add a preloader image
        },
        success: function(data) {
          if (data) {
            button.text('Mehr laden'); // insert new posts
            news_params.current_page++;
            $('.content-box--news').append(data).hide().fadeIn(200);


            if (news_params.current_page == news_params.max_page)
              button.text('Alle News geladen').attr('disabled', 'disabled').addClass('disabled'); // if last page, remove the button

            // you can also fire the "post-load" event here if you use a plugin that requires it
            // $( document.body ).trigger( 'post-load' );
          } else {
            button.remove(); // if no data, remove the button as well
          }
        }
      });
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/modules/news.js